module.exports = __webpack_public_path__ + "img/cases_shsf.b43e488c.jpg";